// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2FReb","unreadBadge":"styles_unreadBadge__3clCB","modalContent":"styles_modalContent__Knto3","modal":"styles_modal__2T4i2"};